import React from 'react'
import { AddButton } from '@e3dc-react/shell/Elements/Buttons'
import { Stack, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FieldArray, useFormikContext } from 'formik'
import { makeStyles } from 'tss-react/mui'
import EMobilityWallboxDischargeTariffsDatePicker from './EMobilityWallboxDischargeTariffsDatePicker'
import EMobilityWallboxDischargeTariffsTextField from './EMobilityWallboxDischargeTariffsTextField'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import CloseIcon from '@mui/icons-material/Close'
import { WallboxTariffsFormData } from '../EMobilityWallboxTariffsEditor'

const useStyles = makeStyles()(theme => ({
  inputContainer: {
    backgroundColor: theme.palette.shades.shade04,
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
  },
}))

/**
 * Field array for inputs for discharging prices.
 * It hols complete array of date pickers and text fields.
 * No param requires.
 * @return JSX element
 */
const EMobilityWallboxDischargeTariffsFieldArray = (): JSX.Element => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { values } = useFormikContext<WallboxTariffsFormData>()
  const { breakpoints } = useTheme()
  const downSm = useMediaQuery(breakpoints.down('sm'))
  return (
    <FieldArray name="dischargePrices">
      {({ push, remove }) => {
        return (
          <Stack>
            <Stack flexDirection={downSm ? 'column' : 'row'} justifyContent={'space-between'} alignItems={'center'} mb={2} mt={5}>
              <Typography>{t('emobility.wallbox.editTariffs.dischargePrice')}</Typography>
              <AddButton
                buttonProps={{ color: 'success' }}
                onClick={() => push({ validFrom: new Date().toDateString(), price: 0 })}
                label={t('emobility.wallbox.editTariffs.addDischargePricing')}
              />
            </Stack>
            <Stack spacing={3}>
              {values.dischargePrices.map((price, index: number) => (
                <Stack className={classes.inputContainer} key={index}>
                  <Grid container columns={13} spacing={4} alignItems={'center'}>
                    <Grid item xs={12} sm={6}>
                      <EMobilityWallboxDischargeTariffsDatePicker validFrom={price.validFrom} index={index} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <EMobilityWallboxDischargeTariffsTextField price={price.price} index={index} />
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton onClick={() => remove(index)}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Stack>
              ))}
            </Stack>
          </Stack>
        )
      }}
    </FieldArray>
  )
}

export default EMobilityWallboxDischargeTariffsFieldArray
